import { Component } from '@angular/core';

@Component({
  selector: 'app-dl',
  templateUrl: './disabled-label.component.html',
  styleUrls: ['./disabled-label.component.scss']
})
export class DisabledLabelComponent {

}
